export default "__VITE_ASSET__CNsVpl2r__"